import { render, staticRenderFns } from "./morph-data.vue?vue&type=template&id=3d14d8b5&"
import script from "./morph-data.vue?vue&type=script&lang=js&"
export * from "./morph-data.vue?vue&type=script&lang=js&"
import style0 from "./morph-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d14d8b5')) {
      api.createRecord('3d14d8b5', component.options)
    } else {
      api.reload('3d14d8b5', component.options)
    }
    module.hot.accept("./morph-data.vue?vue&type=template&id=3d14d8b5&", function () {
      api.rerender('3d14d8b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/morph-parts/morph-data.vue"
export default component.exports